import { uid } from '@/utils';
export const defaultRecurrence = {
    enabled: false,
    frequency: 'weekly',
    count: 10,
    weekdays: [false, false, false, false, false, false, false],
    monthDay: 1,
};
function formatDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
/**
 * Returns the Monday-based weekday index (0=Mon, 6=Sun) for a JS Date.
 */
function isoWeekday(d) {
    return (d.getDay() + 6) % 7;
}
export function generateRecurringDates(startDate, config) {
    const start = new Date(startDate + 'T00:00:00');
    const dates = [];
    if (config.frequency === 'weekly') {
        // Find Monday of start week
        const startWd = isoWeekday(start);
        const monday = new Date(start);
        monday.setDate(monday.getDate() - startWd);
        for (let week = 0; week < config.count; week++) {
            for (let day = 0; day < 7; day++) {
                if (!config.weekdays[day])
                    continue;
                const d = new Date(monday);
                d.setDate(monday.getDate() + week * 7 + day);
                // Skip dates before startDate
                if (d < start)
                    continue;
                dates.push(formatDate(d));
            }
        }
    }
    else {
        // Monthly
        const startYear = start.getFullYear();
        const startMonth = start.getMonth();
        for (let i = 0; i < config.count; i++) {
            const targetMonth = startMonth + i;
            const targetYear = startYear + Math.floor(targetMonth / 12);
            const month = ((targetMonth % 12) + 12) % 12;
            // Last day of target month
            const lastDay = new Date(targetYear, month + 1, 0).getDate();
            const day = Math.min(config.monthDay, lastDay);
            const d = new Date(targetYear, month, day);
            if (d >= start) {
                dates.push(formatDate(d));
            }
        }
    }
    return dates;
}
export function expandWithRecurrence(baseTxs, config) {
    if (!config.enabled || baseTxs.length === 0) {
        return baseTxs;
    }
    const dates = generateRecurringDates(baseTxs[0].date, config);
    if (dates.length === 0)
        return [];
    const seriesId = uid();
    const result = [];
    for (const date of dates) {
        for (const base of baseTxs) {
            result.push({ ...base, date, seriesId });
        }
    }
    return result;
}
